<template>
  <nav class="navbar py-0 navbar-light justify-content-between flex-nowrap flex-row fixed-top">
    <div class="container">

      <div class="row no-gutters">

        <div class="col-2 relative-position">
          <div class="w-100 h-100 user-name-cell text-danger absolute-fix">
            <b class="w-100 pl-5"><trans-text i18nKey="ui[93][1]" :replaceData="{user_name:userName}" :isHtml="true"/></b>
          </div>
        </div>
        <!-- ページ遷移UI -->
        <div class="col-2 relative-position">
          <router-link tag="div" class="w-100 h-100 nav-cell nav-cell-event absolute-fix" :to="{ name: 'mypage::event'}">
            <b class="w-100 pl-5"><trans-text i18nKey="ui['5_1'][1]" :adjustLangFontSizes="{en:0.8}" :isHtml="true"/></b>
          </router-link>
        </div>
        <!-- ページ遷移UI -->
        <div class="col-2 relative-position">
          <router-link tag="div" class="w-100 h-100 nav-cell nav-cell-orderer-info absolute-fix" :to="{ name: 'mypage::orderer_info'}">
            <b class="w-100 pl-5"><trans-text i18nKey="ui['5_1'][2]" :adjustLangFontSizes="{en:0.8}" :isHtml="true"/></b>
          </router-link>
        </div>
        <!-- ページ遷移UI -->
        <div class="col-2 relative-position">
          <router-link tag="div" class="w-100 h-100 nav-cell nav-cell-child-info absolute-fix" :to="{ name: 'mypage::child_info'}">
            <b class="w-100 pl-5"><trans-text i18nKey="ui['5_1'][3]" :adjustLangFontSizes="{en:0.8}" :isHtml="true"/></b>
          </router-link>
        </div>
        <!-- ページ遷移UI -->
        <div class="col-2 relative-position">
          <router-link tag="div" class="w-100 h-100 nav-cell nav-cell-order absolute-fix" :to="{ name: 'mypage::order'}">
            <b class="w-100 pl-5"><trans-text i18nKey="ui['5_1'][4]" :adjustLangFontSizes="{en:0.8}" :isHtml="true"/></b>
          </router-link>
        </div>

        <div class="col-2 ">
          <header-right-menu-p-c @logout="logout" iconSizeClass="fa-2x" headerHeight="50" iconWidth="75" />
        </div>
      </div>
    </div>
  </nav>
</template>

<script>
  import {dd,store,app} from 'systems/imports'
  import HeaderRightMenuPC from 'components/global/partials/HeaderRightMenuPC.vue'


  export default {
    name:"",
    components: {
      HeaderRightMenuPC
    },
    data () {
      return {
      }
    },
    computed:{
      userName(){
        let user = store.get("user")
        return `${user.family_name} ${user.given_name}`
      }
    },
    methods: {
      logout(){
        this.$emit('logout')
      }
    }

  }
</script>


<style lang="scss" scoped>
  .navbar {
    background-size: 10% auto;
    background: url("~assets/header_green_bg.png");
    background-repeat: repeat;
    border-bottom: 3px #7bb700 solid;
    .user-name-cell{
      font-size: .8rem;
      position: relative;
      &:before{
        content: '\f2bd';
        font-size: 1.5rem;
        font-family: FontAwesome;
        position: absolute;
        top: 50%;
        transform: translateY(-50%) translateX(50%);
        left: 0;
      }
      b{
        position: absolute;
        top: 50%;
        transform: translateY(-50%) translateX(-50%);
        left: 50%;
      }
    }
    .nav-cell{
      font-size: 1.2rem;
      line-height: 1.2rem;
      cursor: pointer;
      position: relative;
      &.router-link-active {
        background-color: rgba(129, 246, 112, 0.3);
        &:after{
          font-family: FontAwesome;
          content: '\F0D7';
          position: absolute;
          bottom: -1.1rem;
          left:50%;
          transform: translateY(0) translateX(-50%);
          color: #72b003;
          font-size: 3rem;
        }
      }
      &:before{
        font-size: 1.5rem;
        font-family: FontAwesome;
        position: absolute;
        top: 50%;
        transform: translateY(-50%) translateX(50%);
        left: 0;
        color: #72b003;
      }
      b{
        position: absolute;
        top: 50%;
        transform: translateY(-50%) translateX(-50%);
        left: 50%;
        color: #3a3939;
      }
      &.nav-cell-event:before {
        content: '\f24d';
      }
      &.nav-cell-orderer-info:before {
        content: '\f2ba';
      }
      &.nav-cell-child-info:before {
        content: '\f1ae';
      }
      &.nav-cell-order:before {
        content: '\f0f6';
      }

    }
  }
</style>



// WEBPACK FOOTER //
// PCHeader.vue?08ace28b